module.exports = __webpack_public_path__ + "img/3Dtu.db1a4285.png";